import DeliveryImportScreen from '../../src/components/delivery/DeliveryImportScreen';

export default DeliveryImportScreen;
